export default "__VITE_ASSET__PeUS5TNh__"